<template>
  <div>
    <div v-if="state.enrollment_settings.disclaimer_text != '' && state.enrollment_settings.disclaimer_text != null"
      class="mb-4 bg-white border border-border rounded-md">
      <h2 class="card-title p-4 border-b border-border !m-0">Disclaimer</h2>
      <div class="p-4 disclaimer-content ql-editor" v-html="formattedDisclaimer"></div>
    </div>
    <div class="form-group mb-5">
      <label class="flex items-start gap-3 cursor-pointer">
        <input type="checkbox" class="mt-0.5 w-4 h-4 accent-primary cursor-pointer"
          :checked="localForm.iagree === 'I AGREE'"
          @change="e => { localForm.iagree = e.target.checked ? 'I AGREE' : ''; updateParent('iagree'); }" />
        <span class="font-normal text-mute text-sm">
          Check here to confirm that you agree to the terms listed within this enrollment form.<span class="required-asterisk text-error">*</span>
        </span>
      </label>
      <small v-if="validation.user_form.iagree.$error" class="text-error text-xs mt-1 block">
        Please check this box before proceeding.
      </small>
    </div>
    <div class="form-group mb-5">
      <small class="mt-[8px] flex text-mute text-xs font-normal"
        v-if="state.enrollment_settings.e_sign_text != '' && state.enrollment_settings.e_sign_text != null">
        <img src="@/assets/images/info.svg" alt="info" height="18px" width="18px">
        <span class="px-2">{{ state.enrollment_settings.e_sign_text }}</span>
      </small>
      <label for="eSignature" class="field-label font-normal text-mute text-sm mb-2 inline-block mt-[8px]"> Electronic Signature {{ formattedDate }}
        (Type Full Name)<span class="required-asterisk text-error">*</span></label>
      <input id="eSignature" type="text" placeholder="Enter Your Full Name" class="form" v-model="localForm.eSignature"
        @blur="updateParent('eSignature')" />
      <small v-if="validation.user_form.eSignature.$error" class="text-error text-xs">
        Signature is required.
      </small>
    </div>
  </div>
</template>

<script>
import "@/assets/disclaimer-content.css";
import { normalizeDisclaimerHtml } from "@/utils/disclaimerHtml";

export default {
  name: "SignatureSection",
  props: {
    user_form: {
      type: Object,
    },
    validation: {
      type: Object
    },
    state: {
      type: Object
    }
  },
  data() {
    return {
      formattedDate: new Date().toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      }),
      localForm: this.user_form,
      validationState: {},
      submitting: false,
      submitTimeoutId: null,
    };
  },
  computed: {
    formattedDisclaimer() {
      return normalizeDisclaimerHtml(
        this.state?.enrollment_settings?.disclaimer_text || ""
      );
    },
  },
  methods: {
    updateParent(field) {
      this.$emit("update:user_form", {
        ...this.localForm,
        [field]: this.localForm[field],
      });
      if (this.validation.user_form[field]?.$touch) {
        this.validation.user_form[field].$touch();
      }
      const hasError = this.validation.user_form[field]?.$error || false;
      this.validationState[field] = hasError;
    },
    submitForm() {
      console.log('click')
      if (this.submitting) return;
      this.submitting = true;
      if (this.submitTimeoutId) {
        clearTimeout(this.submitTimeoutId);
      }
      // Safety: release submit lock if callback never returns
      this.submitTimeoutId = setTimeout(() => {
        this.submitting = false;
        this.submitTimeoutId = null;
      }, 30000);
      this.$emit("createMember", (response) => {
        console.log(response,'comp response')
        if (this.submitTimeoutId) {
          clearTimeout(this.submitTimeoutId);
          this.submitTimeoutId = null;
        }
        if (!response || response.data?.status !== "success") {
          this.submitting = false;
        }
      });
    },
    resetForm() {
      this.$emit("resetForm");
    }
  }
};
</script>

<style scoped>
/* WCAG: increase contrast for labels/errors in this section only */
.field-label {
  color: #595959 !important;
}

.required-asterisk {
  color: #b00020 !important;
}

:deep(small.text-error) {
  color: #b00020 !important;
}
</style>
